import React, { useEffect, useState } from "react";
import { FormStep, TextInput, CardLabel, Toast, SearchIcon, SubmitBar, RadioOrSelect } from "@egovernments/digit-ui-react-components";
import Timeline from "../components/Timeline";
import { Tab, Tabs } from "@mui/material";
import TabPanel from "./TabPanel";
import { cloneDeep } from "lodash";
import {  getPattern, convertDateTimeToEpoch, convertDateToEpoch } from "../utils";

const ProfessionalDetails = ({ t, config, onSelect, userType, formData }) => {
    let validation = {};
    sessionStorage.removeItem("currentPincode");
    let isedittrade = window.location.href.includes("edit-application");
    let isrenewtrade = window.location.href.includes("renew-trade");
    const [currentTab, setCurrentTab] = useState("1");
    const userInfo = Digit.UserService.getUser();
    const [canmovenext, setCanmovenext] = useState(isedittrade || isrenewtrade ? false : true);
    const [ownershipCategory, setOwnershipCategory] = useState(formData?.owners?.ownershipCategory);
    const [showToast, setShowToast] = useState(null);
    const [isDisable, setIsDisable] = useState(false);
    const [error, setError] = useState(null);
    const [disable, setDisable] = useState(true)
    const [engineersArr, setEngsArr] = useState([])
    const [selcectedEng, setSelectedEng] = useState(null)
    let Webview = !Digit.Utils.browser.isMobile();
    const ismultiple = ownershipCategory?.code.includes("MULTIPLEOWNERS") ? true : false;
    formData?.owners?.owners?.forEach(owner => {
        if (owner.isPrimaryOwner == "false") owner.isPrimaryOwner = false
    })
    const [fields, setFeilds] = useState(
        (formData?.professionals && formData?.professionals?.professionals) || [{ registrationNumber: "", name: userInfo?.info?.name || "", mobileNumber: userInfo?.info?.mobileNumber || "", address: userInfo?.info?.permanentAddress?.address || "", state: userInfo?.info?.permanentAddress?.state || "", district: userInfo?.info?.permanentAddress?.district || "", tehsil: userInfo?.info?.permanentAddress?.tehsil || "", town: userInfo?.info?.permanentAddress?.town || "", pinno: userInfo?.info?.permanentAddress?.pinNo || "", emailId: userInfo?.info?.emailId || "", class: "", university: userInfo?.info?.permanentAddress?.university || "" }]
    );
    const [erfields, setErFeilds] = useState(
        (selcectedEng && [selcectedEng]) || (formData?.professionals && formData?.professionals?.erprofessionals) || [{ registrationNumber: "", name: selcectedEng?.name || "", mobileNumber: selcectedEng?.mobileNumber || "", address: selcectedEng?.permanentAddress?.address || "", state: selcectedEng?.permanentAddress?.state || "", district: selcectedEng?.permanentAddress?.district || "", tehsil: selcectedEng?.permanentAddress?.tehsil || "", town: selcectedEng?.permanentAddress?.town || "", pinno: selcectedEng?.permanentAddress?.pinNo || "", emailId: selcectedEng?.emailId || "" }]
    );
    function setOwnerName(i, e) {
        let units = [...fields];
        units[i].name = e.target.value;
        setFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function setErOwnerName(i, e) {
        let units = [...erfields];
        units[i].name = e.target.value;
        setErFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function setRegistrationNo(i, e) {
        let units = [...fields];
        units[i].registrationNumber = e.target.value;
        setFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function setErRegistrationNo(i, e) {
        let units = [...erfields];
        units[i].registrationNumber = e.target.value;
        setErFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function setAddress(i, e) {
        let units = [...fields];
        units[i].address = e.target.value;
        setFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function setErAddress(i, e) {
        let units = [...erfields];
        units[i].address = e.target.value;
        setErFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function selectEmail(i, e) {
        let units = [...fields];
        units[i].emailId = e.target.value;
        setFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function selectErEmail(i, e) {
        let units = [...erfields];
        units[i].emailId = e.target.value;
        setErFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function selectDistrict(i, e) {
        let units = [...fields];
        units[i].district = e.target.value;
        setFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function selectErDistrict(i, e) {
        let units = [...erfields];
        units[i].district = e.target.value;
        setErFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function selectTehsil(i, e) {
        let units = [...fields];
        units[i].tehsil = e.target.value;
        setFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function selectErTehsil(i, e) {
        let units = [...erfields];
        units[i].tehsil = e.target.value;
        setErFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function selectTown(i, e) {
        let units = [...fields];
        units[i].town = e.target.value;
        setFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function selectErTown(i, e) {
        let units = [...erfields];
        units[i].town = e.target.value;
        setErFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function selectPinNO(i, e) {
        let units = [...fields];
        units[i].pinno = e.target.value;
        setFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function selectErPinNO(i, e) {
        let units = [...erfields];
        units[i].pinno = e.target.value;
        setErFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function selectClassCat(i, e) {
        let units = [...fields];
        units[i].class = e.target.value;
        setFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function selectUniversity(i, e) {
        let units = [...fields];
        units[i].university = e.target.value;
        setFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }


    function selectState(i, e) {
        let units = [...fields];
        units[i].state = e.target.value;
        setFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function selectErState(i, e) {
        let units = [...erfields];
        units[i].state = e.target.value;
        setErFeilds(units);
        if (units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }

    function setMobileNo(i, e) {
        let units = [...fields];
        units[i].mobileNumber = e.target.value;
        setFeilds(units);
        if (units[i].gender && units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    function setErMobileNo(i, e) {
        let units = [...erfields];
        units[i].mobileNumber = e.target.value;
        setErFeilds(units);
        if (units[i].gender && units[i].mobileNumber && units[i].name) {
            setCanmovenext(false);
        }
    }
    const closeToast = () => {
        setShowToast(null);
      };
    const getOwnerDetails = async (indexValue, eData) => {
        const ownersCopy = cloneDeep(fields);
        const ownerNo = ownersCopy?.[indexValue]?.mobileNumber || "";
        setShowToast(null);


        if (!ownerNo.match(getPattern("MobileNo"))) {
            setShowToast({ key: "true", error: true, message: "ERR_MOBILE_NUMBER_INCORRECT" });
            return;
        }

        if (ownerNo === ownersCopy?.[indexValue]?.userName) {
            setShowToast({ key: "true", error: true, message: "ERR_OWNER_ALREADY_ADDED_TOGGLE_MSG" });
            return;
        }

        const matchingOwnerIndex = ownersCopy.findIndex(item => item.userName === ownerNo);

        if (matchingOwnerIndex > -1) {
            setShowToast({ key: "true", error: true, message: "ERR_OWNER_ALREADY_ADDED" });
            return;
        } else {
            const usersResponse = await Digit.UserService.userSearch(Digit.ULBService.getStateId(), { userName: erfields?.[indexValue]?.mobileNumber }, {});
            if (usersResponse?.user?.length === 0) {
                setShowToast({ key: "true", warning: true, message: "ERR_MOBILE_NUMBER_NOT_REGISTERED" });
                setDisable(true)
                return;
            } else {
                const userData = usersResponse?.user?.[0];
                userData.gender = userData.gender ?  userData?.gender : "";
                if(userData?.dob) userData.dob = convertDateToEpoch(userData?.dob);
                if (userData?.createdDate) {
                    userData.createdDate = convertDateTimeToEpoch(userData?.createdDate);
                    userData.lastModifiedDate = convertDateTimeToEpoch(userData?.lastModifiedDate);
                    userData.pwdExpiryDate = convertDateTimeToEpoch(userData?.pwdExpiryDate);
                  }
                setDisable(false)
                let values = [...ownersCopy];
                if (values[indexValue]) { values[indexValue] = userData; values[indexValue].isPrimaryOwner = fields[indexValue]?.isPrimaryOwner || false; }
                setErFeilds(values);
                if(values[indexValue]?.mobileNumber && values[indexValue]?.name && values[indexValue]?.gender?.code) setCanmovenext(true);
                else setCanmovenext(false);
            }
        }
    }
    useEffect(async () => {
        const tenantId = Digit.ULBService.getStateId()
        const structualEngResponse = await Digit.UserService.userSearch(tenantId, { roleCodes: ["BPA_STRUCTURALENGINEER"]});
        setEngsArr(structualEngResponse?.user)
    }, [])

/////////////Viresh Doc 07-11-2023//////////////
const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
    const goNext = () => {
        const professionaldetail = {}
        professionaldetail.registrationNumber = fields?.[0]?.registrationNumber ||  "";
        professionaldetail.name = fields?.[0]?.name || ""
        professionaldetail.mobileNumber = fields?.[0]?.mobileNumber || ""
        professionaldetail.address = fields?.[0]?.address ||  ""
        professionaldetail.state = fields?.[0]?.state ||  "";
        professionaldetail.district = fields?.[0]?.district ||  ""
        professionaldetail.tehsil = fields?.[0]?.tehsil ||  ""
        professionaldetail.town = fields?.[0]?.town ||  "";
        professionaldetail.pinNo = fields?.[0]?.pinno ||  ""
        professionaldetail.emailId = fields?.[0]?.emailId || ""
        professionaldetail.class = fields?.[0]?.class || "";
        professionaldetail.university = fields?.[0]?.university || ""
        professionaldetail.erregistrationNumber = erfields?.[0]?.registrationNumber || ""
        professionaldetail.ername = erfields?.[0]?.name || ""
        professionaldetail.ermobileNumber = erfields?.[0]?.mobileNumber || ""
        professionaldetail.eraddress = erfields?.[0]?.address || ""
        professionaldetail.erstate = erfields?.[0]?.state || "";
        professionaldetail.erdistrict = erfields?.[0]?.district || ""
        professionaldetail.ertehsil = erfields?.[0]?.tehsil || ""
        professionaldetail.ertown = erfields?.[0]?.town || "";
        professionaldetail.erpinNo = erfields?.[0]?.pinno || ""
        professionaldetail.eremailId = erfields?.[0]?.emailId || ""
        professionaldetail.engineerUuid = erfields?.[0]?.uuid || ""
        if (currentTab=="1") {
            setCurrentTab("2")
            return ;
        }
        onSelect(config.key, professionaldetail);
    };
    const onSkip = () => onSelect();

    return (
        <div>
            <Timeline currentStep={2} flow="BPA" />
      <FormStep onSelect={goNext} onSkip={onSkip} 
      t={t}
       isDisabled={canmovenext || isDisable} forcedError={t(error)}
      cardStyle={{margin: '1.25rem auto 2rem'}}
      >
        <Tabs value={currentTab} onChange={handleChange}>
          <Tab label={`${t("CORE_COMMON_PRIVATE_PROFESSIONAL_INFORMATION")}`} value="1" sx={{ textTransform: 'none', p: '0 1rem' }} />
          <Tab label={`${t("CORE_COMMON_STRUCTURAL_ENGINEER_INFORMATION")}`} value="2" sx={{ textTransform: 'none', p: '0 1rem' }} />
        </Tabs>
        <TabPanel value={currentTab} index="1" sx={{p: 0}}>
        
                            {fields.map((field, index) => {
                                return (
                                    <div key={`${field}-${index}`}>
                                        <div style={{ border: "solid", borderRadius: "5px", padding: "20px 20px 0" , marginTop: "10px", borderColor: "#f3f3f3", background: "#FAFAFA" }}>
                                            <CardLabel style={{ marginBottom: "-15px" }}>{`${t("CORE_COMMON_MOBILE_NUMBER")} *`}</CardLabel>
                                            <div style={{ marginTop: "30px" }}>
                                                <div className="field-container">
                                                    <div style={{ position: "relative", zIndex: "100", left: "35px", marginTop: "-24.5px", marginLeft: Webview ? "-25px" : "-25px" }}>+91</div>
                                                    <TextInput
                                                        style={{ background: "#FAFAFA", padding: "0px 35px" }}
                                                        type={"text"}
                                                        t={t}
                                                        isMandatory={false}
                                                        optionKey="i18nKey"
                                                        name="mobileNumber"
                                                        value={field.mobileNumber}
                                                        onChange={(e) => setMobileNo(index, e)}
                                                        {...(validation = {
                                                            isRequired: true,
                                                            pattern: "[6-9]{1}[0-9]{9}",
                                                            type: "tel",
                                                            title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                                                        })}
                                                    />
                                                    {/* <div style={{ position: "relative", zIndex: "100", right: "35px", marginTop: "-24px", marginRight: Webview ? "-20px" : "-20px" }} onClick={(e) => getOwnerDetails(index, e)}> <SearchIcon /> </div> */}
                                                </div>
                                            </div>
                                            <CardLabel>{`${t("CORE_COMMON_NAME")} *`}</CardLabel>
                                            <TextInput
                                                style={{ background: "#FAFAFA" }}
                                                t={t}
                                                type={"text"}
                                                isMandatory={false}
                                                optionKey="i18nKey"
                                                name="name"
                                                value={field.name}
                                                onChange={(e) => setOwnerName(index, e)}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    type: "text",
                                                    title: t("TL_NAME_ERROR_MESSAGE"),
                                                })}
                                            />
                                            <CardLabel>{`${t("CORE_COMMON_REGISTRATION_NUMBER")} *`}</CardLabel>
                                            <TextInput
                                                style={{ background: "#FAFAFA" }}
                                                t={t}
                                                type={"text"}
                                                isMandatory={false}
                                                optionKey="i18nKey"
                                                name="registrationNumber"
                                                value={field.registrationNumber}
                                                onChange={(e) => setRegistrationNo(index, e)}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    type: "text",
                                                    title: t("TL_NAME_ERROR_MESSAGE"),
                                                })}
                                            />
                                            <CardLabel>{t("BPA_APPLICANT_EMAIL_LABEL") + "*"}</CardLabel>
                                            <TextInput
                                                t={t}
                                                type={"email"}
                                                isMandatory={true}
                                                optionKey="i18nKey"
                                                name="email"
                                                value={field.emailId}
                                                onChange={(e) => selectEmail(index, e)}
                                                //disable={editScreen}
                                                {...{ required: true, pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$", type: "email", title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID") }}
                                            />
                                            <CardLabel>{`${t("CORE_COMMON_ADDRESS")}`}</CardLabel>
                                            <TextInput
                                                style={{ background: "#FAFAFA" }}
                                                t={t}
                                                type={"text"}
                                                isMandatory={false}
                                                optionKey="i18nKey"
                                                name="registrationNumber"
                                                value={field.address}
                                                onChange={(e) => setAddress(index, e)}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    type: "text",
                                                    title: t("TL_NAME_ERROR_MESSAGE"),
                                                })}
                                            />
                                            <CardLabel>{`${t("CORE_COMMON_STATE")}`}</CardLabel>
                                            <TextInput
                                                style={{ background: "#FAFAFA" }}
                                                t={t}
                                                type={"text"}
                                                isMandatory={false}
                                                optionKey="i18nKey"
                                                name="state"
                                                value={field.state}
                                                onChange={(e) => selectState(index, e)}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    type: "text",
                                                    title: t("TL_NAME_ERROR_MESSAGE"),
                                                })}
                                            />

                                            <CardLabel>{t("CORE_COMMON_DISTRICT")}</CardLabel>
                                            <TextInput
                                                t={t}
                                                type={"text"}
                                                isMandatory={true}
                                                optionKey="i18nKey"
                                                name="district"
                                                value={field.district}
                                                onChange={(e) => selectDistrict(index, e)}
                                                //disable={editScreen}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                                                })}
                                            />

                                            <CardLabel>{t("CORE_COMMON_TEHSIL")}</CardLabel>
                                            <TextInput
                                                t={t}
                                                type={"text"}
                                                isMandatory={true}
                                                optionKey="i18nKey"
                                                name="tehsil"
                                                value={field.tehsil}
                                                onChange={(e) => selectTehsil(index, e)}
                                                //disable={editScreen}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                                                })}

                                            />
                                            <CardLabel>{t("CORE_COMMON_TOWN")}</CardLabel>
                                            <TextInput
                                                t={t}
                                                type={"text"}
                                                isMandatory={true}
                                                optionKey="i18nKey"
                                                name="town"
                                                value={field.town}
                                                onChange={(e) => selectTown(index, e)}
                                                //disable={editScreen}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                                                })}
                                            />
                                            <CardLabel>{t("CORE_COMMON_PINNO")}</CardLabel>
                                            <TextInput
                                                t={t}
                                                type={"text"}
                                                isMandatory={true}
                                                optionKey="i18nKey"
                                                name="pinno"
                                                value={field.pinno}
                                                onChange={(e) => selectPinNO(index, e)}
                                                //disable={editScreen}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                                                })}
                                            />
                                            <CardLabel>{t("CORE_COMMON_CLASS_CATEGORIES")}</CardLabel>
                                            <TextInput
                                                t={t}
                                                type={"text"}
                                                isMandatory={true}
                                                optionKey="i18nKey"
                                                name="class"
                                                value={field.class}
                                                onChange={(e) => selectClassCat(index, e)}
                                                //disable={editScreen}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                                                })}
                                            />
                                            <CardLabel>{t("CORE_COMMON_UNIVERSITY_NAME")}</CardLabel>
                                            <TextInput
                                                t={t}
                                                type={"text"}
                                                isMandatory={true}
                                                optionKey="i18nKey"
                                                name="university"
                                                value={field.university}
                                                onChange={(e) => selectUniversity(index, e)}
                                                //disable={editScreen}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                                                })}
                                            />


                                        </div>
                                    </div>
                                );
                            })}
                     
        </TabPanel>
        <TabPanel value={currentTab} index="2" sx={{p: 0}}>
  
                            {erfields.map((field, index) => {
                                return (
                                    <div key={`${field}-${index}`}>
                                        <div style={{ border: "solid", borderRadius: "5px", padding: "20px 20px 0" , marginTop: "10px", borderColor: "#f3f3f3", background: "#FAFAFA" }}>
                                        <CardLabel variant="h6">{`${t("BPA_SELECT_STRUCTURAL_ENGINEER_LABEL")}`}</CardLabel>
                                        <RadioOrSelect
                                        name="engineerType"
                                        optionKey="name"
                                        options={engineersArr}
                                        onSelect={(name) => {
                                            setSelectedEng(name)
                                            setErFeilds([name])
                                        } }
                                        selectedOption={selcectedEng}
                                        t={t}
                                        />
                                        <CardLabel style={{ marginBottom: "-15px" }}>{`${t("CORE_COMMON_MOBILE_NUMBER")} *`}</CardLabel>
                                            <div style={{ marginTop: "30px" }}>
                                                <div className="field-container">
                                                    {/* <div style={{ position: "relative", left: "35px", marginTop: "-24.5px", marginLeft: Webview ? "-25px" : "-25px" }}>+91</div> */}
                                                    <TextInput
                                                        style={{ background: "#FAFAFA"}}
                                                        type={"text"}
                                                        t={t}
                                                        isMandatory={false}
                                                        optionKey="i18nKey"
                                                        name="mobileNumber"
                                                        value={field.mobileNumber}
                                                        onChange={(e) => setErMobileNo(index, e)}
                                                        {...(validation = {
                                                            isRequired: true,
                                                            pattern: "[6-9]{1}[0-9]{9}",
                                                            type: "tel",
                                                            title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                                                        })}
                                                    />
                                                    {/* <div style={{ position: "relative", zIndex: "100", right: "35px", marginTop: "-24px", marginRight: Webview ? "-20px" : "-20px" }} onClick={(e) => getOwnerDetails(index, e)}> <SearchIcon /> </div> */}
                                                </div>
                                            </div>
                                            <CardLabel>{`${t("CORE_COMMON_NAME")} *`}</CardLabel>
                                            <TextInput
                                                style={{ background: "#FAFAFA" }}
                                                t={t}
                                                type={"text"}
                                                isMandatory={false}
                                                optionKey="i18nKey"
                                                name="name"
                                                value={field.name}
                                                onChange={(e) => setErOwnerName(index, e)}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    type: "text",
                                                    title: t("TL_NAME_ERROR_MESSAGE"),
                                                })}
                                            />
                                            <CardLabel>{`${t("CORE_COMMON_REGISTRATION_NUMBER")} *`}</CardLabel>
                                            <TextInput
                                                style={{ background: "#FAFAFA" }}
                                                t={t}
                                                type={"text"}
                                                isMandatory={false}
                                                optionKey="i18nKey"
                                                name="registrationNumber"
                                                value={field.registrationNumber}
                                                onChange={(e) => setErRegistrationNo(index, e)}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    type: "text",
                                                    title: t("TL_NAME_ERROR_MESSAGE"),
                                                })}
                                            />
                                            <CardLabel>{t("BPA_APPLICANT_EMAIL_LABEL") + "*"}</CardLabel>
                                            <TextInput
                                                t={t}
                                                type={"email"}
                                                isMandatory={true}
                                                optionKey="i18nKey"
                                                name="email"
                                                value={field.emailId}
                                                onChange={(e) => selectErEmail(index, e)}
                                                //disable={editScreen}
                                                {...{ required: true, pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$", type: "email", title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID") }}
                                            />
                                            <CardLabel>{`${t("CORE_COMMON_ADDRESS")}`}</CardLabel>
                                            <TextInput
                                                style={{ background: "#FAFAFA" }}
                                                t={t}
                                                type={"text"}
                                                isMandatory={false}
                                                optionKey="i18nKey"
                                                name="registrationNumber"
                                                value={field?.permanentAddress?.address || field?.address}
                                                onChange={(e) => setErAddress(index, e)}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    type: "text",
                                                    title: t("TL_NAME_ERROR_MESSAGE"),
                                                })}
                                            />
                                            <CardLabel>{`${t("CORE_COMMON_STATE")}`}</CardLabel>
                                            <TextInput
                                                style={{ background: "#FAFAFA" }}
                                                t={t}
                                                type={"text"}
                                                isMandatory={false}
                                                optionKey="i18nKey"
                                                name="registrationNumber"
                                                value={field?.permanentAddress?.state || field.state}
                                                onChange={(e) => selectErState(index, e)}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    type: "text",
                                                    title: t("TL_NAME_ERROR_MESSAGE"),
                                                })}
                                            />

                                            <CardLabel>{t("CORE_COMMON_DISTRICT")}</CardLabel>
                                            <TextInput
                                                t={t}
                                                type={"text"}
                                                isMandatory={true}
                                                optionKey="i18nKey"
                                                name="district"
                                                value={field?.permanentAddress?.district || field.district}
                                                onChange={(e) => selectErDistrict(index, e)}
                                                //disable={editScreen}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                                                })}
                                            />

                                            <CardLabel>{t("CORE_COMMON_TEHSIL")}</CardLabel>
                                            <TextInput
                                                t={t}
                                                type={"text"}
                                                isMandatory={true}
                                                optionKey="i18nKey"
                                                name="tehsil"
                                                value={field?.permanentAddress?.tehsil || field.tehsil}
                                                onChange={(e) => selectErTehsil(index, e)}
                                                //disable={editScreen}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                                                })}

                                            />
                                            <CardLabel>{t("CORE_COMMON_TOWN")}</CardLabel>
                                            <TextInput
                                                t={t}
                                                type={"text"}
                                                isMandatory={true}
                                                optionKey="i18nKey"
                                                name="town"
                                                value={field?.permanentAddress?.town || field.town}
                                                onChange={(e) => selectErTown(index, e)}
                                                //disable={editScreen}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                                                })}
                                            />
                                            <CardLabel>{t("CORE_COMMON_PINNO")}</CardLabel>
                                            <TextInput
                                                t={t}
                                                type={"text"}
                                                isMandatory={true}
                                                optionKey="i18nKey"
                                                name="pinno"
                                                value={field?.permanentAddress?.pinNo || field.pinno}
                                                onChange={(e) => selectErPinNO(index, e)}
                                                //disable={editScreen}
                                                {...(validation = {
                                                    isRequired: true,
                                                    pattern: "^[a-zA-Z-.`' ]*$",
                                                    title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                                                })}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
   
        </TabPanel>
               <SubmitBar label={t(`CS_COMMON_NEXT`)} onSubmit={goNext} />
            </FormStep>
            {showToast && <Toast
                error={showToast?.error}
                warning={showToast?.warning}
                label={t(showToast?.message)}
                isDleteBtn={true}
                onClose={closeToast}
            />
            }
        </div>
    );
};

export default ProfessionalDetails;
